import { Link } from "react-router-dom";
import { masterModules } from "../../static/dashboardModules";
import { t } from "../../locales";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../ui/card";
import { Button } from "../ui/button";
import { useCanAccess } from "../../hooks/useCanAccess";

const MasterModules = () => {
  const canAccess = useCanAccess();

  const visibleModules = masterModules.filter((m) => canAccess(m.permission));

  if (visibleModules.length === 0) return null;

  return (
    <section>
      <h2 className="text-base md:text-lg font-semibold text-[#113F67] mb-4">
        {t.dashboard.masterTitle}
      </h2>
      <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
        {visibleModules.map((module) => {
          const labels = (t.dashboard as Record<string, any>)[module.key] as {
            title: string;
            description: string;
          };
          return (
            <Link to={module.href} key={module.key}>
              <Card className="flex flex-col h-44 sm:h-48 md:h-56 lg:h-64 border-2 cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-105 hover:border-[#34699A]">
                <CardHeader className="text-center pb-2 md:pb-4 px-2 md:px-6 pt-3 md:pt-6">
                  <span className="text-xl md:text-3xl lg:text-4xl mb-1 md:mb-2">{module.icon}</span>
                  <CardTitle className="text-sm md:text-lg lg:text-xl font-bold text-[#113F67] leading-tight">
                    {labels.title}
                  </CardTitle>
                  <CardDescription className="text-xs md:text-sm text-gray-600 mb-2 md:mb-4 line-clamp-2 md:line-clamp-3">
                    {labels.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="text-center flex-1 flex flex-col justify-end px-2 md:px-6 pb-3 md:pb-6">
                  <Button variant="outline" size="sm" className="w-full text-xs md:text-sm lg:text-base py-1 md:py-2">
                    {t.dashboard.openButton}
                  </Button>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default MasterModules;
